import { useEffect, useState, memo } from "react";
import { ArrowRight, MagnifyingGlass, ArrowLeft } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const navigate = useNavigate();

  const departments = [
    "Botany",
    "Economics",
    "English",
    "Environmental Science",
    "History",
    "Malayalam",
    "Mathematics",
    "Physical Education",
    "Physics",
    "Chemistry",
    "Zoology",
    "Commerce"
]

  const [isOpen, setIsOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [activeElement, setActiveElement] = useState(null);
  const [activeElementSub, setActiveElementSub] = useState([]);
  const [activeSubElement, setActiveSubElement] = useState(null);
  const [activeSubSubElement, setActiveSubSubElement] = useState([]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); 
  const [navStack, setNavStack] = useState([]); 

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [navElements,setNavElements] = useState(
  [
    {
      element: "Institute",
      subelements: [
        { element: "About", subelements: [], path: "/about" },
        {
          element: "Administration",
          subelements: [
            { element: "Principal", subelements: [], path: "/institute/principal" },
            { element: "Office", subelements: [], path: "/institute/office" },
            { element: "Admin Bodies", subelements: [], path: "/institute/admin-bodies" },
          ],
        },
        {
          element: "Faculty & Research",
          subelements: [
            { element: "Research", subelements: [], path: "/institute/research" },
            { element: "Faculty Directory", subelements: [], path: "/institute/faculties" },
          ],
        },
        { element: "Connect With Us", subelements: [], href: "mailto:nsscollegecherthala@gmail.com" },
        { element: "Policy", subelements: [], path: "/institute/policy" },
      ],
      tagline: "Illuminating Minds, Empowering Futures: NSS College Cherthala.",
    },
    {
      element: "Academics",
      subelements: [
        {
          element: "Departments",
          subelements: [
          ],
        },
        {
          element: "Academic Admission",
          subelements:[
            {
              element:"FYUGP",
              path:"/academics/fyugp"
            }
          ]
        },
        { element: "Announcements", subelements: [], path: "/announcements" },
        {
          element: "Academic Calendar",
          path:'/academics/academic-calendar'
        },
        { element: "Grievance", subelements: [], path: "/grievances" },
      ],
      tagline: `Shaping Minds, Building Futures through Excellence in Education`,
    },
    {
      element: "IQAC",
       subelements: [
        {
          element: "IQAC",
          path: '/iqac'
        },
        {
          element: "Self Study Report",
          path:'/iqac/subs/ssr/?id=ssr'
        },
        {
          element: "AQAR",
          path:'/iqac/subs/aqar/?id=aqar'
        },
        {
          element: "PO, CO, PSO",
          path:'/iqac/subs/outcomes/?id=outcomes'
        },
        {
          element: "Feedback System",
          path:'/iqac/feedback-system/'
        },
        {
          element: "NIRF",
          path:'/iqac/subs/nirf/?id=nirf'
        },
        {
          element: "NEP",
          path:"/iqac/nep"
        },
        {
          element: "Undertaking by Principal",
          href:'/wp-content/uploads/2024/05/Undertaking-by-Principal-NSS-College-Cherthala.pdf'
        },
      ],
      tagline: `Ensuring Quality, Enhancing Excellence, Empowering Growth`,
    },
    {
      element: "Campus",
      subelements: [
        {
          element: "General Facilities", subelements: [
            {
              element: "Library", path: "/campus/library"
            },
            {
              element: "General Facilities", path: "/campus/general-facilities"
            },
            {
              element: "Labs", path: '/campus/general-facilities?facility=labs'
            },
            {
              element: "Cultural", path: '/campus/general-facilities?facility=cultural'
            },
            {
              element: "Infrastructural", path: '/campus/general-facilities?facility=infrastructure'
            },
          ]
        },
        {
          element: "Life at NSS",
          subelements: [
            { element: "Events", subelements: [], path: "/campus/events" },
            { element: "Sports", subelements: [], path: "/campus/sports" },

          ]
        },
        { element: "Birds On Campus", subelements: [], path: "/campus/birds-on-campus" },
      ],
      tagline: `Learn, Grow, Thrive in Our Vibrant Campus Community`,
    },
  ]
  ) 

  useEffect(() => {
    const departmentSubelements = departments.map((department) => ({
      element: department,
      subelements: [],
      path: `/academics/departments?department=${encodeURIComponent(department)}`,
    }));
  
    setNavElements((prevNavElements) => {
      const hasChanged = prevNavElements.some((navItem) =>
        navItem.element === "Academics" &&
        navItem.subelements.some((subItem) =>
          subItem.element === "Departments" &&
          subItem.subelements.length !== departmentSubelements.length
        )
      );
  
      if (!hasChanged) return prevNavElements;
  
      return prevNavElements.map((navItem) =>
        navItem.element === "Academics"
          ? {
              ...navItem,
              subelements: navItem.subelements.map((subItem) =>
                subItem.element === "Departments"
                  ? { ...subItem, subelements: departmentSubelements }
                  : subItem
              ),
            }
          : navItem
      );
    });
  }, [departments]);
  
  

  function handleNavItemClick(nav) {
    if (isMobile) {
      if (nav.subelements?.length) {
        setNavStack((prev) => [...prev, nav]);
      } else if (nav.path) {
        setIsOpen(false);
        navigate(nav.path);
      } else if (nav.href) {
        window.location.href = nav.href;
      }
    } else {
      setActiveElement(nav);
      setActiveElementSub(nav.subelements || []);
      setActiveSubElement(null);
      setActiveSubSubElement([]);
    }
  }

  function handleSubElementClick(subElement) {
    if (isMobile) {
      if (subElement.subelements?.length) {
        setNavStack((prev) => [...prev, subElement]);
      } else if (subElement.path) {
        setIsOpen(false);
        navigate(subElement.path);
      }
    } else {
      setActiveSubElement(subElement);
      setActiveSubSubElement(subElement.subelements || []);
      if (subElement.path) {
        setIsOpen(false);
        navigate(subElement.path);
      }
    }
  }

  function handleBack() {
    setNavStack((prev) => prev.slice(0, -1));
  }

  const currentNavLevel = navStack.length
    ? navStack[navStack.length - 1]
    : { subelements: navElements };

  return (
    <div id="nss-navbar" className="relative">
      {!isOpen && (
        <div className="bg-black p-2 fixed top-10 right-0 z-50 flex items-center space-x-4 text-white">
          <div className="flex items-center">
            <button
              onClick={() => setSearchOpen(!searchOpen)}
              className="flex items-center justify-center w-8 h-8 bg-gray-800 rounded-full"
            >
              <MagnifyingGlass size={20} color="white" />
            </button>
            {searchOpen && (
              <input
                type="text"
                placeholder="Search..."
                className="ml-2 bg-gray-800 text-white border border-gray-600 rounded-md px-3 py-1 transition-all duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-gray-500"
              />
            )}
          </div>

          <button onClick={() => setIsOpen(true)} className="rounded-md">
            <span className="block w-8 h-1 bg-white mb-1"></span>
            <span className="block w-8 h-1 bg-white"></span>
          </button>
        </div>
      )}

      <div
        id="nav-open"
        className={`fixed bg-black inset-0 text-white z-50 transition-opacity duration-500 ${
          isOpen ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div className="flex justify-between items-center p-4">
          <a href="/" className="text-xl font-bold">
            <img
              src="/logo.svg"
              className="filter grayscale contrast-500 brightness-[300] w-3/4 object-contain"
              alt="nss college logo"
            />
          </a>
          <button
            onClick={() => setIsOpen(false)}
            className="text-xl font-bold"
          >
            Close ✕
          </button>
        </div>

        {isMobile ? (
          <div className="p-4">
            {navStack.length > 0 && (
              <button
                onClick={handleBack}
                className="flex items-center gap-2 text-gray-400 hover:text-white"
              >
                <ArrowLeft size={20} />
                Back
              </button>
            )}

            <div className="flex flex-col gap-4 mt-4">
              {currentNavLevel.subelements.map((item, index) => (
                <span
                  key={index}
                  onClick={() => handleNavItemClick(item)}
                  className="hover:text-gray-light text-gray-white cursor-pointer flex items-center gap-1"
                >
                  {item.element}
                  {item.subelements?.length > 0 && <ArrowRight />}
                </span>
              ))}
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-6 gap-8 px-8 py-4 text-2xl font-semibold">
            <div className="flex flex-col gap-8">
              {navElements.map((nav, index) => (
                <h1
                  key={index}
                  onClick={() => handleNavItemClick(nav)}
                  className={`${
                    activeElement?.element === nav.element
                      ? "underline text-gray-white"
                      : "text-gray-light"
                  } hover:text-gray-light text-gray-white cursor-pointer`}
                >
                  {nav.element}
                </h1>
              ))}
            </div>

            {activeElement && (
              <div className="flex flex-col gap-5 text-sm">
                <h1 className="text-2xl font-bold">{activeElement.element}</h1>
                <p className="-mt-4 text-gray-light ">{activeElement.tagline}</p>
                {activeElementSub.map((sub, index) => (
                  <>
                    {!sub.href ? (
                      <span
                        key={index}
                        onClick={() => handleSubElementClick(sub)}
                        className="hover:text-gray-light text-gray-white cursor-pointer flex items-center gap-1"
                      >
                        {sub.element}
                        {sub.subelements?.length > 0 && <ArrowRight />}
                      </span>
                    ) : (
                      <a href={sub.href}>{sub.element}</a>
                    )}
                  </>
                ))}
              </div>
            )}

            {activeSubElement && activeSubSubElement.length > 0 && (
              <div className="flex flex-col gap-4 text-sm whitespace-nowrap">
                {activeSubSubElement.map((subSub, index) => (
                  <a
                    key={index}
                    href={subSub.path || "#"}
                    className="hover:text-gray-light text-gray-white cursor-pointer flex items-center gap-1"
                  >
                    {subSub.element}
                    {subSub.subelements?.length > 0 && <ArrowRight />}
                  </a>
                ))}
              </div>
            )}
          </div>
        )}
         <div className="absolute bottom-4 left-4 right-4 border-t border-gray-700 pt-4">
          <div className="flex justify-left space-x-5 text-sm text-gray-400">
            <span>Quick Links {">"}</span>
            <a href="/grievances" className="hover:text-white">
              Grievances
            </a>
            <a href="/announcements" className="hover:text-white">
              Tenders
            </a>
            <a href="/announcements" className="hover:text-white">
              Careers
            </a>
            <a href="/grievances?grievance=antiragging" className="hover:text-white">
              Anti-Ragging
            </a>
            <a href="/right-to-information" className="hover:text-white">
              RTI
            </a>
            <a href="/about" className="hover:text-white">
              Contact Us
            </a>
          </div>
        </div>
      
      </div>

    </div>
  );
}

export default memo(Navbar);
